"use client"
import Image from "next/image"
import { usePathname } from "next/navigation"
import { LogLevel, useLogger } from "next-axiom"
import React from "react"
import { RiHome4Line, RiRefreshLine } from "react-icons/ri"

import { AppSettings } from "@/settings"

import {
  AuthContainer,
  Body,
  Button,
  ErrorBox,
  ErrorCard,
  Footer,
  H2,
  LogoLink,
  Main,
  MainNavigation,
  Nav,
  SecondaryButton,
} from "./global-error-styles"

export default function GlobalError({ error }) {
  const pathname = usePathname()
  const log = useLogger({ source: "global-error.jsx" })
  let status = error.message === "Invalid URL" ? 404 : 500

  log.logHttpRequest(
    LogLevel.error,
    error.message,
    {
      host: window.location.href,
      path: pathname,
      statusCode: status,
    },
    {
      error: error.name,
      cause: error.cause,
      stack: error.stack,
      digest: error.digest,
    },
  )

  const isIdmApp = AppSettings.isIdmApp()
  const imageStyle = {
    borderRadius: "0.375rem",
    marginBottom: "1rem",
  }

  const PAGE_TITLE = isIdmApp ? "IDM App" : "ADM App"

  const ERROR_PAGE_TITLE = "Da ist etwas schief gelaufen…"

  const ERROR_PAGE_MESSAGE =
    "Die gewünschte Seite konnte leider nicht geladen werden. In der Regel sollten Sie durch erneutes Laden der Seite das Problem beheben und weiterarbeiten können."
  const ERROR_PAGE_SUPPORT_US_1 =
    "Unterstützen Sie uns gerne beim Beheben der Fehler, indem Sie einen Screenshot der Seite an"
  const ERROR_PAGE_SUPPORT_US_2 = "senden und einen kurzen Kommentar zum Fehler schreiben."
  const ERROR_PAGE_SUPPORT_MAIL = "s.kersten@einza.com"
  const ERROR_PAGE_HOME = "Zur Startseite"
  const ERROR_PAGE_RELOAD = "Seite Neuladen"

  return (
    <html lang="de-DE">
      <head>
        <style>{`
        @import url("https://fonts.googleapis.com/css2?family=Roboto+Condensed:ital,wght@0,100..900;1,100..900&display=swap");
      `}</style>
        <title>{PAGE_TITLE}</title>
      </head>
      <Body>
        <AuthContainer>
          <Nav>
            <MainNavigation>
              <LogoLink href="/">
                <Image src="/images/logo.svg" alt="einzA logo image" width={64} height={26} quality={100} />
              </LogoLink>
            </MainNavigation>
          </Nav>
          <Main>
            <ErrorBox>
              <ErrorCard>
                <H2>{ERROR_PAGE_TITLE}</H2>

                <Image
                  className="rounded"
                  src="/images/error.jpeg"
                  style={imageStyle}
                  alt="Farbe ausgelaufen"
                  width={356}
                  height={200}
                  sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                  quality={100}
                />

                <div>{ERROR_PAGE_MESSAGE}</div>
                <br />
                <div>
                  {ERROR_PAGE_SUPPORT_US_1}
                  &nbsp;
                  <a href={`mailto:${ERROR_PAGE_SUPPORT_MAIL}`}>{ERROR_PAGE_SUPPORT_MAIL}</a>
                  &nbsp;
                  {ERROR_PAGE_SUPPORT_US_2}
                </div>

                <Footer>
                  <SecondaryButton rounded secondary onClick={() => window.location.replace("/")} submit>
                    <RiHome4Line size="1.5rem" />
                    {ERROR_PAGE_HOME}
                  </SecondaryButton>

                  <Button rounded seo onClick={() => window.location.reload()}>
                    <RiRefreshLine size="1.5rem" />
                    {ERROR_PAGE_RELOAD}
                  </Button>
                </Footer>
              </ErrorCard>
            </ErrorBox>
          </Main>
        </AuthContainer>
      </Body>
    </html>
  )
}
